import { KpiCard } from '../ui/KpiCard';

/**
 * Renders backend metrics. Structural zeros are shown as real zero values
 * (never hidden), consistent with the empty-safe contract.
 * @param {{ metrics?: { key: string, label: string, value: number }[],
 *   loading?: boolean }} props
 */
export function MetricsCards({ metrics, loading }) {
  if (loading) {
    return (
      <div className="grid gap-3 border-b border-eorig-border p-5 sm:grid-cols-2 sm:p-6 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="h-24 animate-pulse rounded-2xl border border-eorig-border bg-eorig-surface"
          />
        ))}
      </div>
    );
  }

  if (!metrics || metrics.length === 0) {
    return (
      <div className="border-b border-eorig-border p-6 text-sm text-eorig-muted">
        No metrics available yet.
      </div>
    );
  }

  const gridClass =
    metrics.length <= 4
      ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
      : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-5';

  return (
    <div className={`grid gap-3 border-b border-eorig-border p-5 sm:p-6 ${gridClass}`}>
      {metrics.map((metric) => (
        <KpiCard key={metric.key} label={metric.label} value={metric.value} />
      ))}
    </div>
  );
}
